
<template>
  <div style="position: relative;">
    <el-button
      type="primary"
      class="btnBack"
      size="small"
      @click="back"
    >
      &lt;&lt;返回
    </el-button>
    <el-tabs
      v-model="activeName"
      type="card"
    >
      <el-tab-pane
        label="通讯录详细"
        name="contactdtl"
      >
        <contactdtl />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import contactdtl from './contactedit'
export default {
  components: {
    contactdtl
  },
  data() {
    return {
      postId: null,
      activeName: 'contactdtl'
    }
  },
  mounted() {
    this.postId = this.$route.params.id
  },
  created() {
  },
  activated() {
    this.postId = this.$route.params.id
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.btnBack {
  position: absolute;
  right: 5px;
  top: 2px;
  z-index: 99;
}
</style>
